import React, { Component } from "react";
import BykKompletni from "./BykKompletni/BykKompletni";
import Items from "../Items/Items";
import "./IBKompletni.css";
import TextSvisle from "../TextSvisle/TextSvisle";
import TextVodorovne from "../TextVodorovne/TextVodorovne";
import { connect } from "react-redux";

class IBKompletni extends Component {
  render() {
    const uvodNadpis = "Kompletní dělení - úvod"
    const uvod = 'Skot můžeme dále rozdělit na 30 částí, které jsou zde podrobně popsány včetně fotek. Stačí kliknout na jednotlivá čísla a dozvědět se více informací o každé ze 30 částí hovězího masa včetně fotek. '
    
    const { animalPartId, name, img, img2, textSvis, textVod } = this.props;

    let textVodorovne = null;
    let textSvisle = <TextSvisle name={uvodNadpis} text={uvod} />;

    if (this.props.show) {
      textSvisle = (
        <TextSvisle id={animalPartId} name={name} img={img} text={textSvis} />
      );

      textVodorovne = this.props.textVod ? (
        <TextVodorovne id={animalPartId} name={name} img={img} img2={img2} text={textVod} />
      ) : null;
    }

    return (
      <div className="KurzContainer">
        
          <Items />
        
        <div className="KurzBykCollumnContainer">
          <BykKompletni />
          {textVodorovne}
        </div>

        {textSvisle}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    animalPartId: state.text.animalPartId,
    name: state.text.name,
    img: state.text.img,
    img2: state.text.img2,
    textSvis: state.text.textSvis,
    textVod: state.text.textVod,
    show: state.text.show
  };
};

export default connect(mapStateToProps)(IBKompletni);
